/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Save_BlockInputs */

const vi_shop_home_save_block = /** @type {(inputs: Shop_Home_Save_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu khối`)
};

/**

* @param {Shop_Home_Save_BlockInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_save_block = /** @type {((inputs?: Shop_Home_Save_BlockInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Save_BlockInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_save_block(inputs)
});